/**
 * @generated SignedSource<<8cb841920ceb0d311464d5c40f10a996>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "Impulse",
    "kind": "LinkedField",
    "name": "updateImpulseNumbers",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "version",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ImpulseEndpoint",
        "kind": "LinkedField",
        "name": "impulseEndpoints",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "numbers",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "QrsImpulseImplNumbersMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "QrsImpulseImplNumbersMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "79e682e04b94b5bb001252a1eff748eb",
    "id": null,
    "metadata": {},
    "name": "QrsImpulseImplNumbersMutation",
    "operationKind": "mutation",
    "text": "mutation QrsImpulseImplNumbersMutation(\n  $request: UpdateImpulseNumbersRequestInput\n) {\n  updateImpulseNumbers(request: $request) {\n    id\n    version\n    impulseEndpoints {\n      numbers\n    }\n  }\n}\n"
  }
};
})();

node.hash = "aedd818dad7e3bba17e229eaebb1bb16";

module.exports = node;
